import styled from '@emotion/styled';

const TrustWrapper = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: absolute;
  bottom: calc(100% - 30px);
  right: 0;
`;

const TrustElement = styled.div<{ isHighlighted?: boolean }>`
  padding: 0.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  border: ${({ theme, isHighlighted }) =>
    isHighlighted ? '' : `1px solid ${theme.color.grey04}`};
  color: ${({ theme, isHighlighted }) =>
    isHighlighted ? theme.color.white : theme.color.text};
  background-color: ${({ theme, isHighlighted }) =>
    isHighlighted ? theme.color.brand : theme.color.white};
`;

const TrustpilotWrapper = styled.div`
  padding: 0 0.5rem;
  text-align: center;
`;

const TrustpilotBlackPath = styled.path`
  fill: #000;
`;

const TrustpilotGreenPath = styled.path`
  fill: #00b67a;
`;

const TrustpilotDarkGreenPath = styled.path`
  fill: #005128;
`;

const TrustpilotGrayPath = styled.path`
  fill: #cecece;
`;

const TrustpilotWhitePath = styled.path`
  fill: #fff;
`;

const AppPromoWrapper = styled.div`
  display: grid;
  grid-template: 'title title' 'stores qr';
  grid-template-columns: minmax(50px, 1fr) max-content;
  gap: 0.5rem;
`;

const AppPromoHeadline = styled.p`
  grid-area: title;
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.125;

  strong {
    display: block;
    font-family: ${({ theme }) => theme.fontFamily.alternate};
    font-size: 1.25rem;
    line-height: 1.5;
  }
`;

const AppPromoStores = styled.ul`
  grid-area: stores;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const AppPromoQrCode = styled.svg`
  grid-area: qr;
  shape-rendering: crispedges;
  width: 4.5rem;
  height: 4.5rem;
`;

export {
  TrustWrapper,
  TrustElement,
  TrustpilotWrapper,
  TrustpilotBlackPath,
  TrustpilotGreenPath,
  TrustpilotDarkGreenPath,
  TrustpilotGrayPath,
  TrustpilotWhitePath,
  AppPromoWrapper,
  AppPromoHeadline,
  AppPromoStores,
  AppPromoQrCode,
};
